@for (g of bookmarkGroup; track g) {
  <div class="card mb-2" [ngClass]="{ 'bg-danger-subtle': getStatus(g.requestList) === false, approvedCard: getStatus(g.requestList) === true }">
    <div class="card-body py-3 d-flex flex-column">
      <div class="d-flex align-items-center justify-content-between gap-3 mb-2">
        <div class="d-flex gap-1 text-uppercase fw-bold text-secondary align-items-center">
          @if (g.requestList.length > 1) { <div class="fw-bold text-secondary">SHARE</div> }
          @if (g.requestList[0].LoanInfo.InterestRate / 100 >= enums.MINIMUM_EXTRA_EPF_RATE) { <div class="badge text-bg-success">Extra</div> }
        </div>
        <i class="mb-0 text-secondary fas fa-times pointer" style="font-size: 1.25rem" (click)="removeBookmarks(g)"></i>
      </div>
      <div class="d-flex flex-column gap-3">
        @for (request of g.requestList; track request) {
          <div>
            <div class="d-flex flex-wrap gap-1 gap-md-3 align-items-center">
              <div class="d-flex gap-2 align-items-center">
                <h4 class="mb-0">
                  <strong>{{ request.LoanInfo.Scheme === "HUTANG" ? request.LoanInfo.Scheme : "" }} Ticket #{{ request.ID }} {{ request.LoanInfo.Scheme !== "EPF" && request.LoanInfo.Scheme !== "HUTANG" ? "(" + request.LoanInfo.Scheme + ")" : "" }} - {{ request.CompanyCode }}</strong>
                </h4>
                @if (request.SharedProfileId && request.SharedProfileId == request.ProfileId) {
                  <div class="badge text-bg-primary text-uppercase">Main</div>
                }
              </div>
            @if (request.Approved === false) {
              <span class="badge text-bg-danger">
                <h6 class="mb-0"><i class="fas fa-times me-2"></i>Denied</h6>
              </span>
            }
            </div>
            <div class="d-flex flex-wrap gap-2 align-items-center">
              @if (adminAccess[request.CompanyId] !== undefined) {
                <ng-template #popContent>
                  @for (a of adminAccess[request.CompanyId]; track a) {
                    <div class="fs-6">
                      {{ a.Priority }}: <b>{{ a.Username }}</b>
                    </div>
                  }
                </ng-template>
                <ng-template #popTitle>Admins</ng-template>
                <a role="button" class="badge text-decoration-none text-info-emphasis bg-info-subtle border-info-subtle" [ngbPopover]="popContent" [popoverTitle]="popTitle" autoClose="outside" placement="bottom-start auto" container="body"><i class="fas fa-user-friends me-2"></i>{{ adminAccess[request.CompanyId][0].Username }}</a>
              }
              <div class="fw-semibold text-body-secondary text-uppercase">
                {{ request.RequestOn | date: "dd MMM yyyy" }}
              </div>
              @if (request.LoanID !== undefined) {
                <span class="badge" [ngClass]="ticketDateWarning(request.RequestOn, 3) ? 'text-bg-danger' : 'text-bg-secondary opacity-70'"><i class="fas fa-exclamation-triangle"></i> Has Loan</span>
              }
              @if (ticketDateWarning(request.RequestOn, 15)) {
                <span class="badge text-bg-warning"><i class="far fa-calendar-times"></i> More than 15 days</span>
              }
              @if (g.requestList.length > 1) {
                <div class="ms-auto text-end pointer text-secondary" (click)="openLoanRequestModal(request)">
                  <!-- <div class="small fw-bold">On Hand:</div> -->
                  <div class="fw-bold mb-0">RM {{ this.sharedService.calculateTotalOnHand(request.LoanInfo) | number: "1.0-2" }}</div>
                </div>
              }
            </div>
          </div>
        }
      </div>
      <hr />
      <div class="flex-grow-1 d-flex flex-column flex-md-row justify-content-between">
        <div>
          <h5 class="p-0 m-0 viewCustomerLink pointer" style="color: darkslategray" (click)="goToCustomer(g.requestList[0].CustomerId, g.requestList[0].ProfileId)">
            <b>{{ g.requestList[0].CustomerName }} | {{ sharedService.processICNum(g.requestList[0].CustomerIC) }}</b>
          </h5>
          @if (g.requestList[0].Guarantors.length == 0) {
            <span class="badge" [ngClass]="[g.requestList[0].LoanInfo.Scheme !== 'EPF' ? 'text-bg-secondary opacity-70' : 'text-bg-danger']"><i class="fas fa-times"></i> Guarantor</span>
          } @else {
            @for (g of g.requestList[0].Guarantors; track g) {
              <div>
                <div>{{ g.Name }}</div>
              </div>
            }
          }

          @if (approvedAccountList[g.requestList[0].CustomerId] !== undefined) {
            @for (acc of approvedAccountList[g.requestList[0].CustomerId]; track acc) {
              <div>
                <span class="badge text-bg-success"
                  ><i class="far fa-thumbs-up"></i> {{ acc.Bank }} : {{ acc.HolderName }} |
                  {{ acc.AccountNumber }}
                  <i class="far fa-images pointer" (click)="openViewFilesModal(acc)"></i>
                </span>
              </div>
            }
          }

          @if (pendingAccountList[g.requestList[0].CustomerId] !== undefined) {
            @for (acc of pendingAccountList[g.requestList[0].CustomerId]; track acc) {
              <div>
                <span class="badge text-bg-secondary opacity-70"
                  ><i class="fas fa-hourglass-half"></i> {{ acc.Bank }} : {{ acc.HolderName }} |
                  {{ acc.AccountNumber }}
                  <i class="far fa-images pointer" (click)="openViewFilesModal(acc)"></i>
                </span>
              </div>
            }
          }
        </div>

        <div class="text-end align-self-end" [ngClass]="{ pointer: g.requestList.length === 1 }" (click)="openLoanRequestModal(g.requestList)">
          <div class="text-secondary small fw-bold">Total On Hand:</div>
          <div class="fw-bold h5 mb-0">RM {{ getTotalOnHand(g) | number: "1.0-2" }}</div>
        </div>
      </div>
    </div>
  </div>
}
